import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {AppFlowService} from '../services/app-flow.service';
import {SessionStorageService} from '../services/session-storage.service';
import {AppState} from '../models/app-state';
import {findIndex, isEmpty, isNumber, kebabCase} from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FormStartResolver implements Resolve<AppState | null> {
  constructor(
    private appFlowService: AppFlowService,
    private localStorageService: SessionStorageService,
    private router: Router
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AppState | null>  {
    let appState: AppState = this.localStorageService.getAppState();
    if (isEmpty(appState)) {
      appState = await this.appFlowService.startApp();
    }

    const currentFieldName = appState.pages[appState.currentStepIndex];
    const lastFieldIndex = isNumber(appState.lastStepIndex) ? appState.lastStepIndex : -1;

    const routerFieldName = kebabCase(route.params.stepName);
    const routerFieldIndex = findIndex(appState.pages, (item: string) => item === routerFieldName);

    if (currentFieldName && routerFieldIndex === -1) {
      await this.router.navigate([currentFieldName]);
      return appState;
    }

    if (currentFieldName && currentFieldName !== routerFieldName && routerFieldIndex < lastFieldIndex) {
        this.appFlowService.changeStepByName(routerFieldName);
        await this.router.navigate([routerFieldName]);
        return appState;
      }
    if (appState.coleta) {
      return appState;
    }


    try {
      return this.appFlowService.startApp();
    }catch (e) {
      await this.router.navigate(['/']);
      throw e;
    }
  }
}
